import { Box, Card, CardBody, CardHeader, Heading, Text } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { TaskTemplateForm } from '@/components/forms/TaskTemplateForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function TaskTemplateCreatePage() {
  const colors = useThemeColors()
  const navigate = useNavigate()

  return (
    <Box p={4}>
      <Card>
        <CardHeader>
          <Heading size="md">Create Task Template</Heading>
          <Text fontSize="sm" color={colors.textSecondary} mt={1}>
            Define steps and attach field modules from the registry
          </Text>
        </CardHeader>
        <CardBody>
          <TaskTemplateForm onSuccess={() => navigate('/service-catalog/task-templates')} onCancel={() => navigate('/service-catalog/task-templates')} />
        </CardBody>
      </Card>
    </Box>
  )
}
